import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import axios, {AxiosError} from 'axios';
import {openBackdrop, closeBackdrop} from '../backdrop/backdrop'
import {RootState} from '../rootReducer'
import { IReportGet, IReportPaginate} from '../../models/report'
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
// @ts-ignore
import {saveAs} from "file-saver";

import {openNotifier} from "../../store/notifier/notifier";
import {logout} from "../../store/auth/auth";

const api = process.env.REACT_APP_API_URL
const initialStateReport: IReportGet = {
    reports: [],
    loadingReport: false,
    enterprise_id: false,
    seller_id: null,
    commissionable_id: null,
    start_date: null,
    finish_date: null,
    transaction_type_id: false,
    transaction_status_id: false,
}
const initialStatePaginate: IReportPaginate = {
    data: [],
    meta: {
        current_page: 1,
        per_page: '100',
        total: 0
    },
    search: '',
    start_date:null ,
    finish_date:null ,
    loading: false,
    pdfUrl: null,
    openViewer: false
}



export const reportMail = createAsyncThunk<string,
    {
        rejectValue: string
    }>(
    'report/mail',
    async (data, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.get(`${api}/taxi-plan/reports/comission`);
            thunkApi.dispatch(closeBackdrop());
            thunkApi.dispatch(openNotifier({variant: "success", open: true, message: 'Reporte enviado correctamente'}))
            return response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());
            thunkApi.dispatch(openNotifier({variant: "error", open: true, message: 'Error al generar reporte'}))
            return thunkApi.rejectWithValue('error')
        }
    }
)

export const reportPaginate = createAsyncThunk<IReportPaginate,
    {
        page: number,
        items: number
        enterprise_id?: number,
        seller_id?: number,
        start_date?: string,
        finish_date?: string,
        transaction_type_id?: 4 | 5,
        transaction_status_id?: 5 | 6
    },
    {
        rejectValue: string
    }>(
    'report/paginate',
    async (data, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.get(`${api}/taxi-plan/reports/operations?page=${data.page}&items=${data.items}${data.enterprise_id ? '&enterprise_id=' + data.enterprise_id : ''}${data.seller_id ? '&seller_id=' + data.seller_id : ''}${data.start_date ? '&start_date=' + data.start_date : ''}${data.finish_date ? '&finish_date=' + data.finish_date : ''}${data.transaction_type_id ? '&transaction_type_id=' + data.transaction_type_id : ''}${data.transaction_status_id ? '&transaction_status_id=' + data.transaction_status_id : ''}`);
            thunkApi.dispatch(closeBackdrop());
            return response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());
            // @ts-ignore
            if(err?.response.status===401 ||err?.response.status===408){
                thunkApi.dispatch(openNotifier({open:true,variant:"error",message:'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
                thunkApi.dispatch(logout());
            }
            return thunkApi.rejectWithValue('error')
        }
    }
)

//  Para descargar el PDF
export const reportAttendanceDownload = createAsyncThunk<IReportPaginate,
    {
        date_start?: string,
        date_end?: string,
        department?:string[],
        name?:string |number,
        id:string |number
    },
    {
        rejectValue: string
    }>(
    'report/getAttendanceDownload',
    async (data, thunkApi) => {
        thunkApi.dispatch(openBackdrop());
        try {
            // Convertir el arreglo de departamentos en un string válido para la URL
            const departmentParam = data.department
                ? `&department=${data.department.map(encodeURIComponent).join(",")}`
                : "";

            // Construir la URL completa
            const url = `${api}/report/exportReportAsistencia?` +
                (data.date_start ? `date_start=${data.date_start}` : '') +
                (data.date_end ? `&date_end=${data.date_end}` : '') +
                (data.name ? `&name=${data.name}` : '&name=') +
                (data.id ? `&num_colab=${data.id}` : '&num_colab=') +
                departmentParam;

            const response = await axios.get(url, { responseType: "blob" });

            const today = new Date();
            const day = today.getDate() < 10 ? `0${today.getDate()}` : `${today.getDate()}`;
            const months = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Setiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ];
            const year = today.getFullYear();
            const dayGet = data.date_start === data.date_end ? `${data.date_start}` : `${data.date_start}_al_${data.date_end}`;
            const outputFilename = `reporte_de_asistencia_${dayGet}.pdf`;

            //Crear un blob para PDF¿
            const blob = new Blob([response.data], { type: "application/pdf" });
            saveAs(blob, outputFilename);
            thunkApi.dispatch(closeBackdrop());

            return response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());
            // @ts-ignore
            if (err?.response.status === 401 || err?.response.status === 408) {
                thunkApi.dispatch(
                    openNotifier({ open: true, variant: "error", message: "Ha ocurrido un error y el sistema se ha tenido que cerrar" })
                );
                thunkApi.dispatch(logout());
            }
            return thunkApi.rejectWithValue("error");
        }
    }
)

export const reportAttendanceBlob = createAsyncThunk<string,
    {
        date_start?: string,
        date_end?: string,
        department?: string[],
        name?: string | number,
        id: string | number
    },
    {
        rejectValue: string
    }>(
    'report/reportAttendanceBlob',
    async (data, thunkApi) => {
        thunkApi.dispatch(openBackdrop());
        try {
            const departmentParam = data.department
                ? `&department=${data.department.map(encodeURIComponent).join(",")}`
                : "";

            const response = await axios.get(
                `${api}/report/exportReportAsistencia?
                    ${data.date_start ? "date_start=" + data.date_start : ""}
                    ${data.date_end ? "&date_end=" + data.date_end : ""}
                    ${data.name ? "&name=" + data.name : "&name="}
                    ${data.id ? "&num_colab=" + data.id : "&num_colab="}
                    ${departmentParam}`,
                { responseType: "blob" }
            );

            // Crear el blob del PDF
            const blob = new Blob([response.data], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);

            // Abrir en una nueva pestaña
            window.open(blobUrl, '_blank');

            thunkApi.dispatch(closeBackdrop());
            return blobUrl;

        } catch (err) {
            thunkApi.dispatch(closeBackdrop());
            // @ts-ignore
            if (err?.response?.status === 401 || err?.response?.status === 408) {
                thunkApi.dispatch(openNotifier({
                    open: true,
                    variant: "error",
                    message: "Ha ocurrido un error y el sistema se ha tenido que cerrar"
                }));
                thunkApi.dispatch(logout());
            }
            return thunkApi.rejectWithValue("error");
        }
    }
);

//  Para obtener la data de la API y exponerla en front
export const reportAttendance = createAsyncThunk<IReportPaginate,
    {
        date_start?: string,
        date_end?: string,
        department?:string[],
        name?:string |number,
        id:string |number
    },
    {
        rejectValue: string
    }>(
    'report/getAttendance',
    async (data, thunkApi) => {
        thunkApi.dispatch(openBackdrop());
        try {
            // Convertir el arreglo de departamentos en un string válido para la URL
            const departmentParam = data.department
                ? `&department=${data.department.map(encodeURIComponent).join(",")}`
                : "";

            // Construir la URL completa
            const url = `${api}/report/getReportAsistencia?`+
                    `${data.date_start ? "date_start=" + data.date_start : ""}`+
                    `${data.date_end   ? "&date_end=" + data.date_end : ""}`+
                    `${data.name ? "&name=" + data.name : ""}`+
                    `${data.id ? "&num_colab=" + data.id : ""}`+
                    `${departmentParam}`.replace(/\s+/g, '');       //  Eliminación espacio es blanco

            const response = await axios.get(url, { responseType: "json" });


            const today = new Date();
            const day = today.getDate() < 10 ? `0${today.getDate()}` : `${today.getDate()}`;
            const months = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Setiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ];
            //const year = today.getFullYear();
            //const dayGet = data.date_start === data.date_end ? `${data.date_start}` : `${data.date_start}_al_${data.date_end}`;
            //const outputFilename = `reporte_de_asistencia_${dayGet}.pdf`;

            // Crear un blob para PDF
            //const blob = new Blob([response.data], { type: "application/pdf" });
            //saveAs(blob, outputFilename);
            thunkApi.dispatch(closeBackdrop());

            return response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());
            // @ts-ignore
            if (err?.response.status === 401 || err?.response.status === 408) {
                thunkApi.dispatch(
                    openNotifier({ open: true, variant: "error", message: "Ha ocurrido un error y el sistema se ha tenido que cerrar" })
                );
                thunkApi.dispatch(logout());
            }
            return thunkApi.rejectWithValue("error");
        }
    }
)


export const reportSlice = createSlice({
    initialState: initialStatePaginate,
    name: 'report',
    extraReducers: builder => {
        builder

            .addCase(reportPaginate.pending, state => {
                state.loading = true
            })
            .addCase(reportPaginate.fulfilled, (state, {payload}) => {
                const {data, meta} = payload
                state.data = data
                state.meta = meta
                state.loading = false
            })
            .addCase(reportPaginate.rejected, (state, action) => {
                state.loading = true
            })
            //  Para obtener el pdf
            .addCase(reportAttendanceDownload.pending, state => {
                state.loading = true
            })
            .addCase(reportAttendanceDownload.fulfilled, (state, {payload}) => {
                state.loading = false
            })
            .addCase(reportAttendanceDownload.rejected, (state, action) => {
                state.loading = true
            })
            //  Para obtener el pdfpreview
            .addCase(reportAttendanceBlob.pending, state => {
                state.loading = true
            })
            .addCase(reportAttendanceBlob.fulfilled, (state, {payload}) => {
                state.loading = false
                console.log(payload)
                state.pdfUrl=payload
                state.openViewer = true;
            })
            .addCase(reportAttendanceBlob.rejected, (state, action) => {
                state.loading = true
            })

            //Para obtener los datos Json de la API
            .addCase(reportAttendance.pending, state => {
                state.loading = true
            })
            .addCase(reportAttendance.fulfilled, (state, {payload}) => {
                state.loading = false
            })
            .addCase(reportAttendance.rejected, (state, action) => {
                state.loading = true
            })
            //
            .addCase(reportMail.pending, state => {
                state.loading = true
            })
            .addCase(reportMail.fulfilled, (state, {payload}) => {
                state.loading = false
            })
            .addCase(reportMail.rejected, (state, action) => {
                state.loading = false
            })
    },
    reducers: {
        changeEnterprise_id: (state, action: PayloadAction<number>) => {
            state.enterprise_id = action.payload;
        },
        closeViewer: (state) => {
            state.openViewer = false;
            state.pdfUrl = null;
        },
        openViewerManually: (state, action: PayloadAction<string>) => {
            state.pdfUrl = action.payload;
            state.openViewer = true;
        },
        changeSeller_id: (state, action: PayloadAction<number>) => {
            state.seller_id = action.payload;
        },
        changeCommissionable_id: (state, action: PayloadAction<number>) => {
            state.commissionable_id = action.payload;
        },
        changeStart_date: (state, action: PayloadAction<string>) => {
            state.start_date = action.payload;
        },
        changeFinish_date: (state, action: PayloadAction<string>) => {
            state.finish_date = action.payload;
        },
        changeTransaction_type_id: (state, action: PayloadAction<number>) => {
            state.transaction_type_id = action.payload;
        },
        changeTransaction_status_id: (state, action: PayloadAction<number>) => {
            state.transaction_status_id = action.payload;
        },
        reset_Filter: (state) => {
            state.transaction_status_id = false;
            state.data = [];
            state.enterprise_id = false;
            state.seller_id = null;
            state.commissionable_id=null;
            state.transaction_type_id = false;
            state.transaction_status_id = false;
        },
        reset_data: (state) => {
            state.data = [];
        }
    },
})
export const ReportSelector = (state: RootState) => {
    return {
        meta: state.reports.meta,
        data: state.reports.data,
        search: state.reports.search,
        enterprise_id: state.reports.enterprise_id,
        seller_id: state.reports.seller_id,
        commissionable_id: state.reports.commissionable_id,
        start_date: state.reports.start_date,
        finish_date: state.reports.finish_date,
        transaction_type_id: state.reports.transaction_type_id,
        transaction_status_id: state.reports.transaction_status_id,
        loadingReport: state.reports.loading,
        urlPdf:state.reports.pdfUrl,
        openViewer:state.reports.openViewer,
        openViewerManually:state.reports.openViewerManually
    }
}
export const ReportMetaSelector = (state: RootState) => {
    return {
        meta: state.commission.meta,
        data: state.commission.data,
        loadingCommissionPaginate: state.commission.loading,
        search: state.commission.search
    };
};

export const ReportReducer =reportSlice.reducer
export const {
    changeEnterprise_id,
    closeViewer,
    openViewerManually,
    changeTransaction_type_id,
    changeTransaction_status_id,
    changeFinish_date,
    changeSeller_id,
    changeCommissionable_id,
    changeStart_date,
    reset_Filter,
    reset_data,
} = reportSlice.actions;
